import React from 'react'
import { Box } from '@mui/material'
import { TcpFooterWrapper } from '../../NewUDHome/StyledComponents'

function Footer() {
	return (
		<TcpFooterWrapper>
			<Box>&copy; 2023-24 Department of Town & Country Planning, Govt. of Uttar Pradesh</Box>
			<Box>Powered by UPYOG | Copywrite © 2022 National Institute of Urban Affairs | UPYOG License</Box>
		</TcpFooterWrapper>
	)
}

export default Footer
